import axios from "axios";
import md5 from "js-md5";
import Cookie from "js-cookie";
import router from "../router";
import { ValidateToken, GetToken } from "@/api/api";

// console.log(process.env);
const service = axios.create({
  baseURL: process.env.base_url // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 5000 // request timeout
});

// 创建axios实例
// const service = axios.create({
//     baseURL: process.env.VUE_APP_BASE_URL,
//     timeout: 10000
// });

const refreshToken = async () => {
  // 我项目中  更新token 需要吧原有的token 换成refreshToken去请求   这里根据需求可以改动
  // window.localStorage.setItem("token", window.localStorage.refreshToken);
  let User = localStorage.getItem("wx_mp");
  let Headimgurl = "";
  let Nickname = "";
  // if (User) {
  //   Headimgurl = JSON.parse(User).Headimgurl;
  //   Nickname = JSON.parse(User).Nickname;
  // }
  let res = await GetToken({
    AccountType: 1,
    AccountID: process.env.Appid,
    Openid: localStorage.getItem("wx_openid"),
    Headimgurl: Headimgurl,
    Nickname: Nickname
  });
  return res;
};

// request拦截器
service.interceptors.request.use(
  // 在发送请求之前做些什么
  async config => {
    let dataValue = Date.parse(new Date()) / 1000;
    config.headers["call_app_id"] = process.env.redstar_call_app_id; // 请求头中添加tokenid
    const Token = localStorage.getItem("wx_token");
    var token = "";
    if (Token) {
      token = Token;
    }
    config.headers["zy-token"] = token; // 请求头中添加tokenid
    config.headers["Content-Type"] = "application/json"; // 设置数据传输方式
    config.data.CallAppId = process.env.redstar_call_app_id;
    if (config.data.zySign) {
      config.headers["zy-sign"] = config.data.zySign;
    } else {
      config.data.Timestamp = dataValue;
      config.data.Nonce = dataValue;
      config.headers["zy-sign"] = md5(
        "call_app_id=" +
          process.env.redstar_call_app_id +
          "&nonce=" +
          dataValue +
          "&time_stamp=" +
          dataValue +
          "&call_app_secret=" +
          process.env.call_app_secret
      );
    }
    // 请求头中添加tokenid
    // console.log("call_app_id=" + process.env.redstar_call_app_id + "&nonce=" + config.data.Nonce + "&time_stamp=" + config.data.Timestamp + "&call_app_secret=" + process.env.call_app_secret)

    return config;
  },

  error => {
    Promise.reject(error);
  }
);
// response拦截器
//简单点说就是每次得到数据前都要经过这里
service.interceptors.response.use(
  response => {
    if (response) {
      // if (response.data.Code == "10109") {
      //   localStorage.removeItem("wx_token");
      //   localStorage.setItem("fullPath", location.href);
      //   window.location.reload();
      // }
      // if (response.data.Code == "10103") {
      //   localStorage.removeItem("wx_token");
      //   localStorage.setItem("fullPath", location.href);
      //   window.location.reload();
      // }
      return response.data;
    } else {
      Promise.reject(new Error("error"));
    }
  },
  error => {
    if (JSON.stringify(error).includes("10109")) {
    } else {
      // alert(error);
    }
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/api/index.js